module.exports = __webpack_public_path__ + "static/media/image_13.f458605b.png";